import common from './common'
import Vue from 'vue'

export default {
  setApplications(state, payload) {
    state.applications = payload
  },
  deleteApplication(state, payload) {
    state.applications = state.applications.filter( el => el.id != payload.id)
  },
  addApplications(state, payload) {
    let oldAppl = state.applications
    payload.forEach(w => {
      if ( !oldAppl.map(x => x ? x.id : x).some(y => y == w.id)) {
        state.applications.push(w)
      }
    })
  },
  addNewApplication(state, payload) {
    state.applications.unshift(payload)
  },

  editApplicationData(state, payload) {
    let result = common._returnIndexById(state.applications, payload.id)
    if (result.success) {
      state.applications[result.returned] = payload
    }
  },

  addAcceptorsData(state, payload) {
    let result = common._returnIndexById(state.applications, payload.undoc)
    if (result.success) {
      Vue.prototype.$set(state.applications[result.returned], 'acceptors', payload.acceptors)
    }
    
    state.acceptors.unshift(payload)
  },

  addNewAppMessage(state, message) {
    let result = state.applications.find(el => el.id == message.chatKey)
    result.chat.messages.push(message)
  },
  addNewRowMessage(state, message) {
    let result = state.applications.find(el => el.id == message.chatKey.split('/')[0]) 
    if (result) {
      result = result?.rows.find(el => el.chat?.id == message.chatId)
    }
    result?.chat?.messages?.push(message)
  },
  editApplicationRowData(state, payload) {
    if (!state.applications.length) { return }
    let app = state.applications[0]
    let rowSearchResult = common._returnIndexById(app?.rows || [], payload.id)
    if (rowSearchResult.success) {
      if ( !payload.unit ) {
        payload.unit = app?.rows[rowSearchResult.returned].unit
      }
      Object.assign(app?.rows[rowSearchResult.returned],  payload)
    } else {
      app?.rows.push(payload)
    }
  },
  addApplicationRow(state, payload) {
    let app = state.applications.find(x => {
      return x.id = payload.headerId
    })
    app?.rows?.push(payload)
  },
  setStatuses(state, payload) {
    state.statuses = payload
  },
  addAcceptors(state, payload) {
    state.acceptors.unshift(payload)
    let oldAppl = state.acceptors
    payload.forEach(w => {
      if ( !oldAppl.map(x => x ? x.undoc : x).some(y => y == w.undoc)) {
        state.acceptors.push(w)
      }
    })
  },

  setCreateOrdersUsers(state, payload) {
    state.createOrdersUsers = payload
  },

  setPurchasingPlan(state, payload) {
    state.purchasingPlan = payload
  }
}